import { toast } from "react-toastify";
import { observable } from "mobx";
import { api } from "../../api";
import { AppStore } from "../AppStore";
import { downloadBinaryFile } from "../../utils";
import { IEmpresa, newEmpresa } from "../../model";

export class _DecSefaStore {
    obs = observable({
        loading_tasks: false as boolean,
        tasks_decsefa: [] as any,
        tasks_length: 0 as number,
        progressDownload: false as boolean,
        mensagens_pendentes: [] as any,
        open_empresas_mensagens: false as boolean,
        mensagens_decsefa: [] as any,
        mensagens_length: 0 as number,
        loading_mensagens: false as boolean,
        selectedTab: "tarefas" as string,
        programar_dec: false as boolean,
        msgSelectEmpresa: newEmpresa() as IEmpresa,
    })

    async handleTasksPaged(paged: number, cnpj: string) {
        try {
            let data = {
                page: paged,
                limit: 15,
                cnpj: cnpj,
                dec_sefa_new: AppStore.obs1.usuario.conta.dec_sefa_new,
            }

            let resp = await api.post("/api/dec_sefa/task/index", data);

            this.obs.tasks_decsefa = [];
            this.obs.tasks_length = 0

            if (resp.data.count == 0) {
                toast.warning('Nenhuma solicitação foi encontrada, tente novamente mais tarde.', {});
            } else {
                this.obs.tasks_decsefa = resp.data.tasks;
                this.obs.tasks_length = resp.data.count;
            }

        } catch (ex) { }

        this.obs.loading_tasks = false
    }

    async handleMensagensPaged(paged: number, cnpj: string) {
        try {
            let data = {
                page: paged,
                limit: 15,
                cnpj: cnpj,
                dec_sefa_new: AppStore.obs1.usuario.conta.dec_sefa_new,
            }

            let resp = await api.post("/api/dec/index", data);

            this.obs.mensagens_decsefa = [];
            this.obs.mensagens_length = 0

            if (resp.data.itens.length == 0) {
                toast.warning('Nenhuma mensagem foi encontrada, tente novamente mais tarde.', {});
            } else {
                this.obs.mensagens_decsefa = resp.data.itens;
                this.obs.mensagens_length = resp.data.count;
            }

        } catch (ex) { }

        this.obs.loading_mensagens = false
    }

    async handleConsultaMensagens() {
        try {
            let resp = await api.post("/api/dec/index/count", {dec_sefa_new: AppStore.obs1.usuario.conta.dec_sefa_new});

            this.obs.mensagens_pendentes = []
            if (resp.status == 200) {
                this.obs.mensagens_pendentes = resp.data
            }


        } catch (ex) {
            toast.error('Erro ao consultar Saldos, tente novamente mais tarde!', {});
        }
    }

    async handleSaveLog(row: any) {

        let resp = await api.get(`/api/dec/msg/visualiza/${row._id}`)

        if (resp.data.ok) {
            return true
        }

        return false
    }

    async create_task(empresa: any, dec_sefa: boolean) {

        try {

            let params = {
                id: empresa._id,
                dec_sefa: dec_sefa,
                cnpj: empresa.cnpj,
                razao_social: empresa.razao_social,
                inscricao_estadual: empresa.inscricao_estadual,
                dec_sefa_new: AppStore.obs1.usuario.conta.dec_sefa_new,
                uf: empresa.uf
            }

            let resp = await api.post(`/api/dec_sefa/task/create`, params);

            if (resp.data.ok) {

                toast.success("Tarefa criada com sucesso!", {});
                return true

            } else {

                toast.error(resp.data.error, {});

            }

        } catch (ex) {

            toast.error("Erro ao criar tarefa, tente novamente mais tarde.", {});

        }

        return false

    };

    async delete_task(id_task: string, dec_sefa: boolean) {

        try {

            let params = {
                id_task: id_task,
                dec_sefa: dec_sefa,
            }

            let resp = await api.post(`/api/dec_sefa/task/create`, params);

            if (resp.data.ok) {

                toast.success("Tarefa cancelada com sucesso!", {});
                return true

            } else {

                toast.error(resp.data.erro, {});

            }

        } catch (ex) {

            toast.error("Erro ao cancelar, tente novamente mais tarde.", {});

        }

        return false

    };

    async handleAceitaTermos() {

        let resp = await api.get(`/api/dec/termos`);

        if (resp.data.ok) {

            return true
        }

        return false
    }

  async downloadArquivo(fileName: string, ids: string[]) {

    try {
      this.obs.progressDownload = true;

      let data = {
        ids: ids
      }

      let resp = await api.post(`/api/dec/download`, data);

      if (resp.data.ok) {
        const linkSource = `data:application/${resp.data.tipo};base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    } catch (ex) {

      toast.error("Erro ao realizar download xmls, tente novamente mais tarde.", {});

    }

    this.obs.progressDownload = false;

  }

}

export const DecSefaStore = new _DecSefaStore();
